import { useStore } from '../../stores/useStore'
import { INSTRUMENT_TYPES } from '../../types'

export default function Sidebar() {
  const tracks = useStore((state) => state.tracks)
  const modules = useStore((state) => state.modules)
  const selectedTrackId = useStore((state) => state.selectedTrackId)
  const selectedModuleId = useStore((state) => state.selectedModuleId)
  const selectedModuleType = useStore((state) => state.selectedModuleType)
  const addTrack = useStore((state) => state.addTrack)
  const removeTrack = useStore((state) => state.removeTrack)
  const updateTrack = useStore((state) => state.updateTrack)
  const selectTrack = useStore((state) => state.selectTrack)
  const selectModule = useStore((state) => state.selectModule)

  const instruments = modules.filter((m) => m.type === 'instrument') as import('../../types').Instrument[]

  const handleReplaceInstrument = (instrumentId: string, trackId: string) => {
    updateTrack(trackId, { instrumentId })
    selectTrack(trackId)
    selectModule('instrument', instrumentId)
  }

  return (
    <aside className="daw-sidebar">
      <div className="track-list-header">
        <span style={{ fontSize: '13px', fontWeight: 600, color: '#ebebeb' }}>Tracks</span>
        <button className="btn-icon" onClick={addTrack} title="Add Track">+</button>
      </div>

      <div className="track-list">
        {tracks.map((track) => {
          const isSelected = track.id === selectedTrackId
          return (
            <div
              key={track.id}
              className={`track-item ${isSelected ? 'selected' : ''}`}
              style={isSelected ? { background: '#1f2f33' } : undefined}
              onClick={() => selectTrack(track.id)}
            >
              <div className="track-color" style={{ background: track.color || '#118C9B' }} />
              <input
                type="text"
                value={track.name}
                onChange={(e) => updateTrack(track.id, { name: e.target.value })}
                onClick={(e) => e.stopPropagation()}
              />
              <button
                className="btn-icon"
                onClick={(e) => {
                  e.stopPropagation()
                  removeTrack(track.id)
                }}
                style={{ background: '#c14746', borderColor: '#c14746', opacity: 0.85 }}
                title="Delete Track"
              >
                ×
              </button>
            </div>
          )
        })}
      </div>

      <div style={{ borderTop: '1px solid #373737', background: '#1a1a1a', padding: '12px', flexShrink: 0 }}>
        <div style={{ fontSize: '12px', fontWeight: 600, color: '#ebebeb', marginBottom: '10px' }}>Instruments</div>
        <div className="instrument-rack">
          {INSTRUMENT_TYPES.map((type) => {
            const inst = instruments.find((i) => i.instrumentType === type)
            const isSelected = inst && inst.id === selectedModuleId && selectedModuleType === 'instrument'
            return (
              <div
                key={type}
                className={`instrument-card ${isSelected ? 'selected' : ''}`}
                onClick={() => {
                  if (!inst) {
                    const newInst = {
                      id: `inst-${type.toLowerCase()}-${Date.now()}`,
                      name: type,
                      type: 'instrument' as const,
                      instrumentType: type,
                      enabled: true,
                      selected: false,
                      parameters: { attack: 0.05, release: 0.25, depth: 0.45, rate: 0.2, freq: 0.5, reso: 0.25, damp: 0.2, wet: 0.15, delay: 0.25, width: 0.5, threshold: 0.7, ratio: 0.6 },
                    }
                    useStore.setState((s) => ({ modules: [...s.modules, newInst] }))
                    return
                  }
                  selectModule('instrument', inst.id)
                  if (selectedTrackId) {
                    handleReplaceInstrument(inst.id, selectedTrackId)
                  }
                }}
              >
                <div className="instrument-swatch" style={{ background: '#118C9B' }} />
                <div className="instrument-name">{type}</div>
              </div>
            )
          })}
        </div>

        <div style={{ fontSize: '12px', fontWeight: 600, color: '#ebebeb', marginTop: '18px', marginBottom: '10px' }}>Effects</div>
        <div className="instrument-list">
          {['reverb', 'delay', 'filter', 'distortion', 'chorus', 'limiter'].map((fxType) => {
            const mod = modules.find((m) => m.type === 'effect' && (m as import('../../types').Effect).effectType === fxType)
            const isSelected = mod && mod.id === selectedModuleId && selectedModuleType === 'effect'
            return (
              <button
                key={fxType}
                className={`btn ${isSelected ? 'btn-primary' : ''}`}
                style={{ textTransform: 'capitalize', fontSize: '12px' }}
                onClick={() => {
                  if (!mod) {
                    const newFx = {
                      id: `fx-${fxType}-${Date.now()}`,
                      name: fxType,
                      type: 'effect' as const,
                      effectType: fxType,
                      enabled: true,
                      selected: false,
                      parameters: { depth: 0.4, rate: 0.2, freq: 0.5, reso: 0.3, damp: 0.25, wet: 0.2, delay: 0.3, width: 0.5, attack: 0.05, release: 0.25, threshold: 0.75, ratio: 0.6 },
                    }
                    useStore.setState((s) => ({ modules: [...s.modules, newFx] }))
                    return
                  }
                  selectModule('effect', mod.id)
                }}
              >
                {fxType}
              </button>
            )
          })}
        </div>
      </div>
    </aside>
  )
}
